import { useState, useEffect } from "react";

export const CONSENT_STORAGE_KEY = "ubk_cookie_consent";
const CONSENT_EVENT = "ubk-consent-change";

export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const setConsent = (value) => {
  localStorage.setItem(CONSENT_STORAGE_KEY, value);
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
};

export const useCookieConsent = () => {
  const [consent, setConsentState] = useState(getConsent());

  useEffect(() => {
    const handler = () => setConsentState(getConsent());
    window.addEventListener(CONSENT_EVENT, handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener(CONSENT_EVENT, handler);
      window.removeEventListener("storage", handler);
    };
  }, []);

  return consent;
};
